import React from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";

function CTA() {
  return (
    <section className="relative py-24 md:py-32 bg-levi-bg overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-levi-primary/20 via-transparent to-levi-accent/10" />
      <div className="absolute inset-0 bg-grid-red bg-[size:80px_80px] opacity-30" />

      <div className="container-xl relative">
        <Reveal className="max-w-4xl mx-auto text-center">
          <span className="eyebrow">Let's build</span>
          <h2 className="mt-6 display-xl text-levi-text">
            Got something <br />
            worth <span className="text-levi-primary">shipping?</span>
          </h2>
          <p className="mt-8 max-w-xl mx-auto text-lg text-levi-muted">
            We take on a small number of engagements each quarter. Tell us about your
            product — we'll tell you if we're the right team for it.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <a href="#contact" className="btn-primary">
              Start a project
              <ArrowRight size={16} />
            </a>
            <a href="mailto:tphuc.work@gmail.com" className="btn-ghost">
              tphuc.work@gmail.com
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default CTA;
